const skinned = new THREE.Vector4();
const skinVertex = new THREE.Vector4();
const skinIndex = new THREE.Vector4();
const skinWeight = new THREE.Vector4();
const temp4 = new THREE.Vector4();
const boneMatX = new THREE.Matrix4();
const boneMatY = new THREE.Matrix4();
const boneMatZ = new THREE.Matrix4();
const boneMatW = new THREE.Matrix4();

function applyBone({
    vector, attrSkinIndex, attrSkinWeight, index, bindMatrix, bindMatrixInverse, boneMatrices
}) {
    skinIndex.fromBufferAttribute(attrSkinIndex, index);
    skinWeight.fromBufferAttribute(attrSkinWeight, index);

    boneMatX.fromArray(boneMatrices, skinIndex.x * 16);
    boneMatY.fromArray(boneMatrices, skinIndex.y * 16);
    boneMatZ.fromArray(boneMatrices, skinIndex.z * 16);
    boneMatW.fromArray(boneMatrices, skinIndex.w * 16);

    skinVertex
        .set(vector.x, vector.y, vector.z, 1)
        .applyMatrix4(bindMatrix);

    skinned
        .set(0, 0, 0, 0)
        .add(temp4.copy(skinVertex).applyMatrix4(boneMatX).multiplyScalar(skinWeight.x))
        .add(temp4.copy(skinVertex).applyMatrix4(boneMatY).multiplyScalar(skinWeight.y))
        .add(temp4.copy(skinVertex).applyMatrix4(boneMatZ).multiplyScalar(skinWeight.z))
        .add(temp4.copy(skinVertex).applyMatrix4(boneMatW).multiplyScalar(skinWeight.w))
        .applyMatrix4(bindMatrixInverse);

    vector.set(skinned.x, skinned.y, skinned.z);

    return vector;
}

export default applyBone;
export { applyBone };